var render = function render(){var _vm=this,_c=_vm._self._c;return _c('binds-ripple',{attrs:{"binds-disabled":!_vm.bindsRipple || _vm.disabled,"binds-event-trigger":false,"binds-active":_vm.bindsRippleActive},on:{"update:bindsActive":active => _vm.$emit('update:bindsRippleActive', active)}},[_c('div',{staticClass:"binds-button-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }